import React from 'react';
import RootWrapper from './src/components/Wrapper/Root';

// eslint-disable-next-line react/display-name,react/prop-types
export default ({ element }) => <RootWrapper>{element}</RootWrapper>;
